<template>
  <div class="charge-warp" v-loading="loading">
    <div class="table-warp">
      <customTable height="600" :cell-style="{ borderColor: '#DDDDDD' }" @pageChange="pageChange" tooltip-effect="dark"
        :tableData="tableData" :column="column" :total="total" :currentPage="searchForm.pageNum"
        :currentPageSize="searchForm.pageSize" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }"
        border>
        <template slot="action" slot-scope="row">
          <el-button type="text" @click="handleAgin((row.row))">重试</el-button>
        </template>
      </customTable>
    </div>
  </div>
</template>

<script>
import customTable from '@/components/customTable/customTable'
import { isNull,isNullObj } from '@/utils/validateBase'
import { statementDTO } from '@/DTO/index'
export default {
  components: { customTable },
  data() {
    return {
      tableData: [],
      column: [
        { label: "序号", type: 'index', width: 60 },
        { label: "医馆", prop: 'deptName' },
        { label: "患者", prop: 'patientName' },
        { label: "手机号", prop: 'patientPhone' },
        { label: "类型", formatter:(row)=>{
          const obj={ 1:'出票',2:'退票'}
           return obj[row.type] || '-' } },
        { label: "收费/退费完成时间", prop: 'completeTime' },
        { label: "订单号（推雨诺的订单号）", prop: 'orderNumber',width: 300 },
        { label: "失败原因", prop: 'failReason',width: 400 },
        { label: "操作", slotName: 'action' },
      ],
      total: 0,
      searchForm: {
        pageNum: 1,
        pageSize: 20
      },//搜索条件
      loading: false, // 全局loading
    }
  },
  created() {
    this.getData()
  },
  methods: {
    pageChange(obj) {
      let { current, size } = obj
      this.searchForm.pageNum = current
      this.searchForm.pageSize = size
      this.getData()
    },
    //获取列表
    async getData() {
      this.loading = true
      let { code, rows, total } = await statementDTO.getPushList(this.searchForm)
      this.loading = false
      if (code === 200) {
        this.tableData = rows
        this.total = total
      }
    },
    //重试
    async handleAgin(row){
      if((isNull(row)) || isNullObj(row)) return
      let {ctOrderId,type,status} = row
      this.loading = true
      let { code } = await statementDTO.rePush({ctOrderId,type,status})
      this.loading = false
      if(code===200){
        this.$message.success('重试成功')
        this.getData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.charge-warp {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .table-warp {
    margin-top: 16px;
    flex: 1;

    /deep/.el-table {
      border-color: #DDDDDD;
    }

    /deep/.pagination-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 0;

      .total-tips {
        color: #667182;
        font-size: 14px;
      }
    }
  }
}
</style>